export default __webpack_public_path__ + "static/media/partners2.d27b05fb.jpg";